import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, AppProviders } from "@/components/app/App";
import { sharedEnvironment } from "@akina/config";
import { initializeErrorTrackingService } from "@akina/infra";
import "./main.css";

initializeErrorTrackingService(sharedEnvironment.environment, sharedEnvironment.sentryDsn);

const domElement = document.getElementById("root");

if (domElement) {
  createRoot(domElement).render(
    <StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </StrictMode>,
  );
}
